import { ExtendedUseFormReturn } from '../../../hooks/providers/useFormHooks';
import { UpdateVendorFormFieldsMap, UpdateVendorFormProps } from '../interfaces';

export const useFormRevalidate = (formMethods: ExtendedUseFormReturn<UpdateVendorFormProps>) => {
  const isFieldHasError = (fieldName: UpdateVendorFormFieldsMap): boolean => !!formMethods.getFieldState(fieldName)?.error?.message;

  const reValidateDomesticAddress = () => {
    const fieldsList = [UpdateVendorFormFieldsMap.LINE_1, UpdateVendorFormFieldsMap.CITY, UpdateVendorFormFieldsMap.STATE, UpdateVendorFormFieldsMap.POSTAL_CODE];
    fieldsList.forEach((field) => {
      if (isFieldHasError(field)) {
        formMethods.resetField(field);
      }
    });
  };

  const reValidateDomesticWire = () => {
    const fieldsList = [UpdateVendorFormFieldsMap.WIRE_ACCOUNT_NUMBER, UpdateVendorFormFieldsMap.WIRE_ROUTING_NUMBER];
    fieldsList.forEach((field) => {
      if (isFieldHasError(field)) {
        formMethods.resetField(field);
      }
    });
  };

  const reValidateAch = () => {
    const fieldsList = [UpdateVendorFormFieldsMap.ACH_ROUTING_NUMBER, UpdateVendorFormFieldsMap.ACH_ACCOUNT_NUMBER];
    fieldsList.forEach((field) => {
      if (isFieldHasError(field)) {
        formMethods.resetField(field);
      }
    });
  };

  const reValidateInternationalWire = () => {
    const fieldsList = [
      UpdateVendorFormFieldsMap.INTER_COUNTRY,
      UpdateVendorFormFieldsMap.SWIFT,
      UpdateVendorFormFieldsMap.IBAN,
      UpdateVendorFormFieldsMap.INTER_PHONE,
      UpdateVendorFormFieldsMap.INTER_PHONE_STATUS,
      UpdateVendorFormFieldsMap.INTER_LINE_1,
      UpdateVendorFormFieldsMap.INTER_STATE,
      UpdateVendorFormFieldsMap.INTER_POSTAL_CODE,
      UpdateVendorFormFieldsMap.INTER_CITY,
    ];
    fieldsList.forEach((field) => {
      if (isFieldHasError(field)) {
        formMethods.resetField(field);
      }
    });
  };
  return { reValidateAch, reValidateDomesticAddress, reValidateDomesticWire, reValidateInternationalWire };
};
